/**
 * @flow
 * @relayHash 5769b252b4f0afb75cb18f08e93d0aff
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePurchaseOrderModalQueryVariables = {||};
export type CreatePurchaseOrderModalQueryResponse = {|
  +vendors: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +vendorNumber: string,
        +name: string,
      |}
    |}>
  |}
|};
export type CreatePurchaseOrderModalQuery = {|
  variables: CreatePurchaseOrderModalQueryVariables,
  response: CreatePurchaseOrderModalQueryResponse,
|};
*/


/*
query CreatePurchaseOrderModalQuery {
  vendors {
    edges {
      node {
        id
        vendorNumber
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "vendors",
    "storageKey": null,
    "args": null,
    "concreteType": "VendorConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "VendorEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Vendor",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "vendorNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreatePurchaseOrderModalQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreatePurchaseOrderModalQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "CreatePurchaseOrderModalQuery",
    "id": null,
    "text": "query CreatePurchaseOrderModalQuery {\n  vendors {\n    edges {\n      node {\n        id\n        vendorNumber\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '62ff4eb5bb5e84e8a929b7f8a9a3000a';
module.exports = node;
